<template>
    <modal @close="closeWindow" :large="true" :class="['reservation-modal', 'dark-top']">
        <div slot="title">
            <h2>Cancel Refund</h2>
        </div>
        <div slot="body">
            <div class="p-4">
                <div class="">
                    <v-select
                        :options="getCancelRefundReasons"
                        label="text"
                        placeholder="Select reason"
                        v-model="selectedReason">
                    </v-select>

                    <div class="mt-3">
                        <label>Describe the refund cancelation reason</label>
                        <textarea class="w-100" v-model="reasonText">
                        </textarea>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer">
            <button type="button" class="btn cancel wider" @click="clickCancel">Cancel</button>
            <button type="button" class="btn ok wider" :disabled="!isCancelRefundValid" :class="{'disabled notAllowed': isCancelRefundValid == false}" @click="confirmClick">
                <span v-if="isLoading">Loading</span>
                <span v-else>Confirm</span>
            </button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import Loader from '@/tools/loaders/loader1'

    export default {
        created: function() {
        },
        data: function() {
            return {
                selectedReason: null,
                reasonText: '',
                isLoading: false,
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedRefund',
                'getCancelRefundReasons',
                'getSelectedReservation',
            ]),
            isCancelRefundValid: function () {
                if (!this.selectedReason) {
                    return false;
                }

                if (this.isLoading) {
                    return false;
                }

                if (this.selectedReason.id === 0) {
                    return this.reasonText.trim() !== '';
                }

                return true;
            },
        },
        methods: {
            ...mapActions([
                'closeModal',
                'cancelRefund',
            ]),
            confirmClick: function () {
                const refundableStatus = [2,10];
                this.isLoading = true;

                if (refundableStatus.includes(this.getSelectedRefund.status)) {
                    this.$set(this.getSelectedReservation.updateFlags, 'totalRefund', true);
                }

                this.cancelRefund({
                    reservation: this.getSelectedReservation,
                    refund: this.getSelectedRefund,
                    reason: this.selectedReason,
                    description: this.reasonText,
                }).then(response => {
                    this.eventHub.$emit('saveReservation')
                    this.isLoading = false
                    this.closeModal()
                })

                let returnedRefund = JSON.parse(JSON.stringify(this.getSelectedRefund))
                returnedRefund.amountResumeValue = 99

                // update refund
                this.eventHub.$emit('updateRefund', returnedRefund)
            },
            clickCancel: function () {
                this.closeModal();
            },
            closeWindow: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            Loader,
            vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_utility.scss";
</style>



// WEBPACK FOOTER //
// RefundCancel.vue?123a963a